import React from "react";

const HairMaskHow = () => {
  return (
    <div className="hairSalonInSahakaraWhat">
      <h3>How Our Hair Mask Treatments Work</h3>
      <li>
        <h6> 1. Assessment:</h6>
        <p>
          Our experts begin with a detailed analysis of your hair type and
          specific concerns.{" "}
        </p>
      </li>
      <li>
        <h6> 2. Preparation:</h6>
        <p>
          Your hair is cleansed to remove dirt and buildup, ensuring maximum
          absorption of the mask.
        </p>
      </li>
      <li>
        <h6> 3. Application:</h6>
        <p>
          The hair mask is evenly applied, focusing on areas that need extra
          care.
        </p>
      </li>
      <li>
        <h6> 4. Relaxation:</h6>
        <p>
          Sit back and relax as the mask works its magic, often accompanied by a
          gentle scalp massage to enhance penetration and relaxation.
        </p>
      </li>
      <li>
        <h6> 5. Rinse and Finish:</h6>
        <p>
          The mask is rinsed off thoroughly, and your hair is styled to
          perfection, leaving you with a refreshed and polished look.
        </p>
      </li>
    </div>
  );
};

export default HairMaskHow;
